module.exports = __webpack_public_path__ + "static/img/sbfh-title.dde2a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/sbfh-title.png
// module id = VjsA
// module chunks = 1